export class QuestionsModel {
    question: string;
    qno: number;
    /**
     * 
     * @param qno 
     * @param question 
     */
    constructor(qno: number, question: string) {
        this.qno = qno;
        this.question = question;
    }
}